module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")]), _vm._v("T CREPT UP OUT OF MEXICO, TOUCHING FIRST ALONG the brackish Pecos and spreading then in all directions, a cancerous blight burning a scar upon the land.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Just another dry spell, men said at first. Ranchers watched waterholes recede to brown puddles of mud that their livestock would not touch. They watched the rank weeds shrivel as the west wind relentlessly sought them out and smothered them with its hot breath. They watched the grass slowly lose its green, then curl and fire up like dying cornstalks.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Farmers watched their cotton make an early bloom in its stunted top, produce a few half-hearted bolls and then wither.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Men grumbled, but you learned to live with the dry spells if you stayed in West Texas; there were more dry spells than wet ones. No one expected another drouth like that of ’33. And the really big dries like 1918 came once in a lifetime.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Why worry? they said. It would rain this fall. It always had.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("But it didn’t. And many a boy would become a man before the land was green again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573490c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429912938_fm02.vue
// module id = 78
// module chunks = 0